// src/main.tsx — React entrypoint. Applies LS theme before first paint, then
// mounts the app inside the auth + query providers.
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { PulseProvider } from "@goodbetter/pulse-sdk";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { queryClient } from "./lib/queries";
import { getServiceToken } from "./lib/api";
import { PULSE_API_BASE } from "./lib/env";
import { applyLsTheme, resolveLsTheme } from "./lib/ls-theme";
import "./index.css";

applyLsTheme(resolveLsTheme());

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root mount point missing from index.html");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* The SDK shares the app's QueryClient and reads the same in-memory S2S
          token the direct API client uses (getServiceToken). The auth layer
          owns sign-in; the SDK never persists the token. */}
      <PulseProvider
        apiBaseUrl={PULSE_API_BASE}
        getToken={getServiceToken}
        queryClient={queryClient}
      >
        <AuthProvider>
          <App />
        </AuthProvider>
      </PulseProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
